export default __webpack_public_path__ + "static/media/640_dummy2016-klempner01-mobile-de.34db3d22.png";